/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function UrgentFormFlagIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_1732_916" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1732_916)">
        <path d="M6.99997 13.5V20C6.99997 20.2125 6.92807 20.3906 6.78425 20.5343C6.64045 20.6781 6.46225 20.75 6.24965 20.75C6.03707 20.75 5.85898 20.6781 5.7154 20.5343C5.5718 20.3906 5.5 20.2125 5.5 20V5.40385C5.5 5.14777 5.58662 4.93311 5.75987 4.75988C5.93311 4.58663 6.14777 4.5 6.40385 4.5H12.848C13.0614 4.5 13.2519 4.56699 13.4196 4.70098C13.5873 4.83494 13.6929 5.00898 13.7365 5.22308L13.9961 6.5H18.5961C18.8522 6.5 19.0668 6.58626 19.2401 6.75878C19.4133 6.93128 19.5 7.14503 19.5 7.40003V14.6001C19.5 14.8551 19.4133 15.0688 19.2401 15.2413C19.0668 15.4137 18.8522 15.5 18.5961 15.5H14.1519C13.9385 15.5 13.748 15.433 13.5804 15.299C13.4127 15.165 13.3071 14.991 13.2635 14.7769L13.0039 13.5H6.99997Z" fill="#AE0C0C" />
      </g>
    </svg>
  );
}

export default UrgentFormFlagIcon;
